import chroma from 'chroma-js';

const styleConstants = {
	componentSpacing: '4rem',
	stackedBarHeight: 270,
	fonts: {
		sourceSans: "'Source Sans Pro', sans-serif",
		bodyLineHeight: 1.5,
		headingLineHeight: 1.125
	},
	fontWeights: {
		thin: 200,
		light: 300,
		book: 400,
		medium: 600,
		bold: 700,
		black: 800
	},
	colors: {
		themeBlue: '#5c9cb6',
		themeBluePale: '#f2f7f9',
		themeBlueLight: '#e7f0f4',
		themeBlueMedium: '#adccda',
		theme1: '#0067ab',
		theme3: '#dfa923',
		theme4: '#5ea59a',
		theme5: '#8fbc8b',
		theme6: '#ff7775',
		theme7: '#ab6e8f',
		theme8: '#c293ac',
		theme9: '#f99775',
		gray1: '#fafafa',
		gray2: '#f3f3f3',
		gray3: '#e5e5e5',
		gray4: '#bababa',
		gray5: '#888',
		gray6: '#464646'
	}
};

const gniGroupColors = {
	LIC: styleConstants.colors.themeBlue,
	'L-MIC': styleConstants.colors.theme4,
	'U-MIC': styleConstants.colors.theme5
};

const sectorColors = {
	Public: styleConstants.colors.theme9,
	Government: styleConstants.colors.theme6,
	Donor: styleConstants.colors.theme9,
	Private: styleConstants.colors.theme7,
	'Private Subsidized': styleConstants.colors.theme7,
	'Private Non-Subsidized': styleConstants.colors.theme8
};

const methodColors = {
	Sterilization: styleConstants.colors.theme4,
	Implant: styleConstants.colors.theme9,
	IUD: styleConstants.colors.theme3,
	Injectable: styleConstants.colors.theme6,
	Pill: styleConstants.colors.theme8,
	Condom: styleConstants.colors.theme5,
	Other: styleConstants.colors.themeBlue
};

const mapColors = {
	LIC: styleConstants.colors.themeBlue,
	LICND: styleConstants.colors.themeBlue,
	LMIC: styleConstants.colors.theme4,
	LMICND: 'transparent',
	O: 'transparent',
	UMIC: styleConstants.colors.theme5,
	UMICND: styleConstants.colors.theme5,
	UMICNI: styleConstants.colors.theme5
};

const pattern1 = 'M 0 0 L 5 5 M 4 -1 L 6 1 M -1 4 L 1 6';
const pattern2 = 'M 5 0 L 0 5 M 1 -1 L -1 1 M 6 4 L 4 6';

const createMapPattern = path => ({
	path: {
		d: path,
		strokeWidth: 1
	},
	width: 5,
	height: 5
});

const mapPatterns = {
	LICND: createMapPattern(pattern1),
	UMICND: createMapPattern(pattern1),
	UMICNI: createMapPattern(pattern2)
};

export const toolbarHeight = '5rem';

export const darken = (color, hslPercent) => lighten(color, -hslPercent);

export const lighten = (color, hslPercent) => {
	const chromaColor = chroma(color);

	return chromaColor.set('hsl.l', chromaColor.get('hsl.l') + hslPercent).hex();
};

export default {
	...styleConstants,
	colors: {
		...styleConstants.colors,
		primary: styleConstants.colors.themeBlue
	},
	categoryColors: {
		gniGroupColors,
		sectorColors,
		methodColors,
		mapColors
	},
	categoryPatterns: {
		mapPatterns
	}
};
